/**
 * TanStack Query hooks for `custom-export-schedule-daily-weekly-custom-interva`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customExportScheduleDailyWeeklyCustomIntervaQueryKeys,
	type CreateCustomExportScheduleDailyWeeklyCustomIntervaBody,
	type ListCustomExportScheduleDailyWeeklyCustomIntervaResponse,
	type CustomExportScheduleDailyWeeklyCustomIntervaRow,
} from "./api";

export function useCustomExportScheduleDailyWeeklyCustomIntervaList(): UseQueryResult<ListCustomExportScheduleDailyWeeklyCustomIntervaResponse, Error> {
	return useQuery({
		queryKey: customExportScheduleDailyWeeklyCustomIntervaQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomExportScheduleDailyWeeklyCustomIntervaCreate(): UseMutationResult<CustomExportScheduleDailyWeeklyCustomIntervaRow, Error, CreateCustomExportScheduleDailyWeeklyCustomIntervaBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customExportScheduleDailyWeeklyCustomIntervaQueryKeys.all });
		},
	});
}

export function useCustomExportScheduleDailyWeeklyCustomIntervaDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customExportScheduleDailyWeeklyCustomIntervaQueryKeys.all });
		},
	});
}
